// This file is auto-generated. DO NOT EDIT THIS FILE MANUALLY!
//
// To regenerate this file, run yarn higharc gen doc-schema (which automatically updates this file)
// or run yarn higharc gen doc-schema-entity-mappings directly.

/**
 * Mapping from schema names back to their corresponding doc entity types.
 * Only includes schema names for entity types that exist in docSchemaEntityTypeMap.
 */
export const docSchemaNameToEntityType = {
  Annotation: "ANNOTATION",
  Asset: "ASSET",
  AutoDimensionSelector: "SELECTOR",
  Block: "BLOCK",
  CaseworkCatalogSettings: "CASEWORK_CATALOG_SETTINGS",
  CaseworkDescriptor: "CASEWORK_DESCRIPTOR",
  Ceiling: "CEILING",
  CipConcrete: "CIP_COMPONENT",
  Column: "COLUMN",
  ColumnCatalogSettings: "COLUMN_CATALOG_SETTINGS",
  ColumnDescriptor: "COLUMN_DESCRIPTOR",
  Component: "COMPONENT",
  ComponentInstance: "COMPONENT_INSTANCE",
  CompositeLevel: "COMPOSITE_LEVEL",
  ContentReplicator: "CONTENT_REPLICATOR",
  ContentTemplate: "CONTENT_TEMPLATE",
  ContentTemplateInstance: "CONTENT_TEMPLATE_INSTANCE",
  DataSequence: "DATA_SEQUENCE",
  DataTable: "DATA_TABLE",
  DocOption: "OPTION",
  DocOptionEffect: "OPTION_EFFECT",
  DocOptionLock: "OPTION_LOCK",
  DocOptionRule: "OPTION_RULE",
  DocOptionSet: "OPTION_SET",
  DocOptionSetOverrides: "OPTION_SET_OVERRIDES",
  DocOptionTemplate: "OPTION_TEMPLATE",
  DocRef: "DOC_REF",
  DocWallPlaneFilter: "WALL_PLANE_FILTER",
  DoorCatalogSettings: "DOOR_CATALOG_SETTINGS",
  DoorDescriptorCustom: "DOOR_DESCRIPTOR",
  Drawing: "DRAWING",
  DrawingCatalogSettings: "DRAWING_CATALOG_SETTINGS",
  DrawingRef: "DRAWING_REF",
  EdgeBehavior: "EDGE_BEHAVIOR",
  EdgeModifier: "EDGE_MODIFIER",
  Effect: "EFFECT",
  ElectricalDevice: "ELECTRICAL_DEVICE",
  ElectricalItemCatalogSettings: "ELECTRICAL_ITEM_CATALOG_SETTINGS",
  ElectricalRule: "ELECTRICAL_RULE",
  Elevation: "ELEVATION",
  ElevationView: "ELEVATION_VIEW",
  EntitySettings: "ENTITY_SETTINGS",
  Facade: "FACADE",
  FacadeSpanStratum: "FACADE_SPAN_STRATUM",
  FacadeSweepStratum: "FACADE_SWEEP_STRATUM",
  FloorAssemblyFinishLayerOverride: "FLOOR_FINISH",
  FloorAssemblyOverride: "FLOOR",
  FloorSystemExternal: "FLOOR_SYSTEM",
  Foundation: "FOUNDATION",
  FoundationAssemblyEntity: "FOUNDATION_ASSEMBLY",
  FoundationComponentEntity: "FOUNDATION_COMPONENT",
  FoundationSystem: "FOUNDATION_SYSTEM",
  FrameFloorAssemblyEntity: "FRAME_FLOOR_ASSEMBLY",
  FramingComponentEntity: "FRAMING_COMPONENT",
  FreeformWallEntity: "FREEFORM_WALL",
  GlobalParameter: "GLOBAL_PARAMETER",
  Group: "GROUP",
  HeaderAssemblyEntity: "HEADER_ASSEMBLY",
  InPlaceElectricalLayout: "ELECTRICAL_LAYOUT",
  InstanceOptionSet: "INSTANCE_OPTION_SET",
  Label: "LABEL",
  LevelDef: "LEVEL",
  LoadDescriptor: "LOAD_DESCRIPTOR",
  LocalParameter: "LOCAL_PARAMETER",
  MasonryComponentEntity: "MASONRY_COMPONENT",
  Modifier: "MODIFIER",
  Opening: "OPENING",
  Palette: "PALETTE",
  PlanAreaMeasurement: "MEASUREMENT",
  PlanSetTemplate: "PLAN_SET_TEMPLATE",
  PlanSetTemplateConfig: "PLAN_SET_TEMPLATE_CONFIG",
  PlanView: "PLAN_VIEW",
  PostPlacement: "RAILING_POST",
  Preset: "PRESET",
  ProfileCatalogSettings: "PROFILE_CATALOG_SETTINGS",
  ProfileEntity: "PROFILE",
  ProfileExtrusionDescriptor: "PROFILE_EXTRUSION_DESCRIPTOR",
  PropAttributes: "PROP",
  PropInstance: "PROP_INSTANCE",
  Railing: "RAILING",
  RailingCatalogSettings: "RAILING_CATALOG_SETTINGS",
  RailingDefaultSetting: "RAILING_SETTING",
  ReferenceGeom: "REFERENCE_GEOM",
  ReportableUnitDesignation: "REPORTABLE_UNIT_DESIGNATION",
  Roof: "ROOF",
  RoofDormerPlacement: "DORMER",
  RoofOpeningPlacement: "ROOF_OPENING",
  RoofSide: "ROOF_SIDE",
  RoofSystem: "ROOF_SYSTEM",
  RoofVolume: "ROOF_VOLUME",
  RoomLayout: "ROOM_LAYOUT",
  RoomLayoutInstance: "ROOM_LAYOUT_INSTANCE",
  RuleBasedSelector: "RULE_BASED_SELECTOR",
  RuleBasedSelectorInstance: "RULE_BASED_SELECTOR_INSTANCE",
  SectionView: "SECTION_VIEW",
  SettingsFragment: "SETTINGS",
  SettingsSet: "SETTINGS_SET",
  SheathingComponentEntity: "SHEATHING_COMPONENT",
  Sheet: "SHEET",
  Site: "SITE",
  SiteShape: "SITE_SHAPE",
  SkylightPlacement: "SKYLIGHT",
  SlabComponentEntity: "SLAB_COMPONENT",
  SlabFloorAssemblyEntity: "SLAB_FLOOR_ASSEMBLY",
  StairBlock: "STAIR_BLOCK",
  StairCatalogSettings: "STAIR_CATALOG_SETTINGS",
  StairSetting: "STAIR_SETTING",
  StairSystem: "STAIR_SYSTEM",
  StaticRoom: "ROOM",
  StructuralMaterial: "STRUCTURAL_MATERIAL",
  SystemParameter: "SYSTEM_PARAMETER",
  Underlay: "UNDERLAY",
  View3D: "VIEW_3D",
  ViewOverride: "VIEW_OVERRIDE",
  Viewport: "VIEWPORT",
  ViewSelector: "VIEW_SELECTOR",
  ViewTemplate: "VIEW_TEMPLATE",
  ViewTemplateOverride: "VIEW_TEMPLATE_OVERRIDE",
  WallCasework: "CASEWORK",
  WallCatalogSettings: "WALL_CATALOG_SETTINGS",
  WallPlaneAssemblyEntity: "WALL_PLANE_ASSEMBLY",
  WallPlaneRuleEntity: "WALL_PLANE_RULE",
  WallPlaneTrimEntity: "WALL_PLANE_TRIM",
  WallType: "WALL_TYPE",
  WindowCatalogSettings: "WINDOW_CATALOG_SETTINGS",
  WindowDescriptorCustom: "WINDOW_DESCRIPTOR",
} as const;

// This file is auto-generated. DO NOT EDIT THIS FILE MANUALLY!
//
// To regenerate this file, run yarn higharc gen doc-schema (which automatically updates this file)
// or run yarn higharc gen doc-schema-entity-mappings directly.
